import * as React from "react";
import { forwardRef } from "react";
const SvgIconCheckedDisabled = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 22, height: 22, viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { opacity: 0.4 }, /* @__PURE__ */ React.createElement("rect", { x: 0.5, y: 0.5, width: 21, height: 21, rx: 2.5, fill: "#5265FF", stroke: "#0C1119" }), /* @__PURE__ */ React.createElement("path", { d: "M15.5802 6.58002L16.9902 8.00002L8.99023 16L4.99023 12.01L6.41023 10.6L8.99023 13.17L15.5802 6.58002Z", fill: "white" })));
const ForwardRef = forwardRef(SvgIconCheckedDisabled);
export { ForwardRef as ReactComponent };
